import { BODY_TYPE_FILTER_CATEGORY } from '../../../core/reducers/vehicleListFilters';
const getBodyTypeFiltersFromLookupTables = (lookupTables) => {
    var _a, _b, _c;
    const allFilters = lookupTables.items && ((_a = lookupTables.items[0]) === null || _a === void 0 ? void 0 : _a.filters);
    const bodyTypeFilters = allFilters === null || allFilters === void 0 ? void 0 : allFilters.filter((filter) => filter.name === BODY_TYPE_FILTER_CATEGORY);
    const filterItems = ((_c = (_b = bodyTypeFilters === null || bodyTypeFilters === void 0 ? void 0 : bodyTypeFilters[0]) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.map((filterItem) => ({
        [filterItem.name]: filterItem.filterName.value,
    }))) || [];
    return filterItems;
};
export default getBodyTypeFiltersFromLookupTables;
